export const mapById = <T extends { id: number }>(arr: T[]): Map<number, T> => {
  return arr.reduce((acc, val) => acc.set(val.id, val), new Map());
};
